const growthPerRow = (data, uniqueRowTitles, upperScale, lowerScale) => {
  const range = (upperScale - lowerScale) || 1;

  return uniqueRowTitles.reduce((acc, key) => {
    acc[key] = data.map((current, index) => {
      if (index === 0) return null;

      const prevValue = data[index - 1][key]?.value;
      const currentValue = current[key]?.value;

      if (typeof prevValue !== 'number' || typeof currentValue !== 'number') return null;

      const pct = ((currentValue - prevValue) / range) * 100;
      return Math.round(pct * 10) / 10; // number with one decimal
    });
    return acc;
  }, {});
};

export default growthPerRow;
